"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import { Link } from "react-router";
import { useShellRootPath } from "../../hooks";
import { Logo as CommonLogo, Tooltip } from "capitalrx-components-2.0/lib/general";
import { EnvironmentTag } from "capitalrx-components-2.0/lib/shell";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import styles from "./Logo.module.css";
export const Logo = () => {
  const rootPath = useShellRootPath();
  return /* @__PURE__ */ jsx(Tooltip, { content: "Dashboard", children: (ref) => /* @__PURE__ */ jsxs(Shelf, { spacing: "medium", children: [
    /* @__PURE__ */ jsx(Link, { ref, className: `${styles.logoLink} logo`, to: rootPath, "data-testid": "test__applicationHomeButton", tabIndex: 3, children: /* @__PURE__ */ jsx(CommonLogo, { name: "judi-white-knockout-horizontal" }) }),
    /* @__PURE__ */ jsx(EnvironmentTag, { environment: site == null ? void 0 : site.useAnalyticsAPIEnv }),
    /* @__PURE__ */ jsx(Shelf.Spacer, {})
  ] }) });
};
